import { InjectionToken } from '@angular/core';
import { ActionType } from '@ngxs/store';


export const SUCCESS_ACTIONS_EVENTS_FEATURE = new InjectionToken<ActionType[]>('success_actions_events_feature');

export const ERROR_ACTIONS_EVENTS_FEATURE = new InjectionToken<ActionType[]>('error_actions_events_feature');
